import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide02Challenge({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--surface)]" data-id="element-29">
      <div className="h-full grid grid-cols-2" data-id="element-30">
        {/* Left panel - Timeline visual */}
        <div className="flex items-center justify-center p-[clamp(2rem,4vw,4rem)]" data-id="element-31">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="flex flex-col gap-[clamp(2rem,4vw,3rem)]" data-id="element-32">
            <div className="flex items-center gap-4" data-id="element-33">
              <div className="w-4 h-4 rounded-full bg-[var(--brand-green)]" data-id="element-34" />
              <span className="text-[clamp(1.25rem,2vw,1.75rem)] font-semibold text-[var(--fg)]" data-id="element-35">
                Live Webinar
              </span>
            </div>
            <div className="ml-2 w-0.5 h-[clamp(3rem,6vw,5rem)] bg-gray-300" data-id="element-36" />
            <div className="flex items-center gap-4" data-id="element-37">
              <div className="w-4 h-4 rounded-full bg-gray-400" data-id="element-38" />
              <span className="text-[clamp(1.25rem,2vw,1.75rem)] font-semibold text-[var(--muted)]" data-id="element-39">
                Replay Available
              </span>
            </div>
            <div className="ml-2 w-0.5 h-[clamp(3rem,6vw,5rem)] bg-gray-300" data-id="element-40" />
            <div className="flex items-center gap-4" data-id="element-41">
              <div className="w-4 h-4 rounded-full bg-gray-300" data-id="element-42" />
              <span className="text-[clamp(1.25rem,2vw,1.75rem)] font-semibold text-gray-400" data-id="element-43">
                Engagement Declines
              </span>
            </div>
          </motion.div>
        </div>

        {/* Right panel - Content */}
        <div className="bg-[var(--brand-green)] flex flex-col justify-between p-[clamp(2rem,4vw,4rem)]" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-45">
            <p className="text-[var(--brand-green-lighter)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(1rem,2vw,1.5rem)]" data-id="element-46">
              The Challenge
            </p>
            <h2 className="text-white font-bold text-[clamp(2rem,4.5vw,4rem)] leading-[1.1] mb-[clamp(2rem,4vw,3rem)]" data-id="element-47">
              <span className="text-[var(--brand-green-lighter)]" data-id="element-48">Most</span>{' '}
              webinar engagement ends when the webinar ends
            </h2>
            <p className="text-white/70 text-[clamp(1rem,1.75vw,1.25rem)] leading-relaxed mb-[clamp(2rem,4vw,3rem)]" data-id="element-49">
              Even excellent webinar content often has a short engagement window
              despite substantial investment in faculty, content development,
              promotion and production.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-[clamp(1.5rem,3vw,2.5rem)]" data-id="element-50">
            <p className="text-white text-[clamp(1.125rem,2vw,1.75rem)] font-semibold leading-snug" data-id="element-51">
              What if one webinar could fuel weeks of educational engagement?
            </p>
          </motion.div>

          <div className="flex justify-end" data-id="element-52">
            <span className="text-white/40 text-sm" data-id="element-53">{index + 1}</span>
          </div>
        </div>
      </div>
    </div>;
}